import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { REQUEST_STATUS } from "../../../../../app/constants";
import { ERROR_STRING } from "../../../../../app/errors";
import { humanReadableDate } from "../../../../../app/utils";
import { BackButton, Button, ErrorMark, LineSeperator } from "../../../../../components/RegularComponents";
import { setCurrentAgentInternalNoteList } from "../../../../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../../../../redux/slice/businessLicenceApplicationSlice";
import { setInternalNoteList } from "../../../../../redux/slice/primaryAgencyApplicationSlice";

export const AddInternalNote = (props) => {
    const { appData, internalNoteCategory, applicationType, applicationMode, isAgencyApplication, handleBack, noteCategories } = props;
    const dispatch = useDispatch()

    const [noteText, setNewNoteText] = useState("");
    const [applicationSaveError, setApplicationSaveError] = useState(false)
    const [saveRequestProgress, setSaveRequestProgress] = useState(REQUEST_STATUS.IDLE)

    const internalNotes = useMemo(() => appData.internalNoteList?.length > 0 ? appData.internalNoteList : [], [appData.internalNoteList])

    const [noteCategoryOption, setNoteCategoryOption] = useState(props.internalNoteCategory);
    const noteCategoryOptions = useMemo(() => {
      return noteCategories
        ?.filter((category) => !category.hiddenForInternalNoteTab)
        .map((noteCategory) => (
          <option key={noteCategory.key} value={noteCategory.key}>
            {noteCategory.key}
          </option>
        ));
    }, [noteCategories]);
    const userData = useSelector(state => state.userAuth?.userData);
    const userName = useMemo(() => `${userData.firstname} ${userData.lastname}`, [userData]);

    const onAddNoteClick = () => {
        if (!noteText) {
            return;
        }

        const noteCategory = handleBack ? noteCategoryOption : internalNoteCategory
        if (!noteCategory) {
            console.error("Can't save without a note category");
            return;
        }

        const newNote = { note: noteText, changeType: "SAVE", internalNoteCategory: noteCategory };
        const newNotes = [...internalNotes, newNote];

        if (isAgencyApplication) {
            dispatch(setInternalNoteList(newNotes));
        } else {
            dispatch(setCurrentAgentInternalNoteList(newNotes))
        }

        setSaveRequestProgress(REQUEST_STATUS.IN_PROGRESS)
        setApplicationSaveError(false)

        dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
        .then(data => {
            setSaveRequestProgress(REQUEST_STATUS.IDLE)
            setNewNoteText("")
        })
        .catch(err => {
            // could not save the note. Show error
            setSaveRequestProgress(REQUEST_STATUS.ERROR)
            setApplicationSaveError(true)
        })
    }

    return (
        <>
            {handleBack ? <BackButton onClick={handleBack} /> : null}
            <div className="row" style={{ background: "#eee", marginBottom: "1rem", padding: "1rem" }}>
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-9">
                            <h3>Add a note</h3>
                        </div>
                    </div>


                    {handleBack && (
                        <>
                            <div className="row" style={{ marginTop: "0.5rem" }}>
                                <div className="col-xs-4">
                                    <label
                                        className="ns-label"
                                        id={"add-note-created-by-label"}>
                                        Created by
                                    </label>
                                </div>
                                <div className="col-xs-4">
                                    {userName}
                                </div>
                            </div>
                            <LineSeperator />
                            <div className="row" style={{ marginTop: "0.5rem" }}>
                                <div className="col-xs-4">
                                    <label
                                        className="ns-label"
                                        id={"add-note-date-label"}>
                                        Date
                                    </label>
                                </div>
                                <div className="col-xs-4">
                                    {humanReadableDate(Date.now())}
                                </div>
                            </div>
                            <LineSeperator />
                            <div className="row" style={{ marginTop: "0.5rem" }}>
                                <div className="col-xs-12">
                                    <label
                                        className="ns-label"
                                        id={"add-note-select-label"}
                                        htmlFor={"add-note-select-input"}>
                                        Subject
                                    </label>
                                    <div className={"select fw-20"}>
                                        <select
                                            id={"add-note-select-input"}
                                            name={"add-note-select-input"}
                                            value={noteCategoryOption}
                                            onChange={(e) => {
                                                // console.log(e);
                                                setNoteCategoryOption(e.target.value)
                                            }}>
                                            {noteCategoryOptions}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}


                    <div className="row" style={{ marginTop: "0.5rem" }}>
                        <div className="col-xs-12">
                            <label
                                className="ns-label"
                                id={"add-note-created-by-label"}>
                                Note
                            </label>
                            <div className={"textarea fw-25 inlineDisplay"}>
                                <textarea
                                    className="ns-input"
                                    // style={{ width: "100%" }}
                                    rows={4}
                                    cols={60}
                                    maxLength={1000}
                                    value={noteText || ""}
                                    onInput={(e) => {
                                        setNewNoteText(e.target.value)
                                    }}>
                                </textarea>

                            </div>
                        </div>
                    </div>

                    <div className="row bottomMarginMedium">
                        <div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
                            <Button id="save-internal-note"
                                disabled={!noteText} 
                                className="btn btn-success" 
                                text={"Save note"} 
                                onClick={onAddNoteClick} 
                                showProgress={saveRequestProgress === REQUEST_STATUS.IN_PROGRESS}
                            />
                            {applicationSaveError && ErrorMark()}
                            {applicationSaveError && 
                            <div className="ns-error-message help-block topMarginNormal">
                                <span className="ns-visually-hidden">Error:</span>
                                {ERROR_STRING.APPLICATION_SAVE_ERROR}
                            </div>}
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}